import { useState } from "react";

import type { DeviceEnrollment, DeviceInstallation } from "./api";
import { InstallationProgress } from "./InstallationProgress";
import { displayLocale } from "./localization";

export function EnrollmentCommand({
  deviceLabel,
  enrollment,
  onClose,
  onInstallationChange,
}: {
  deviceLabel: string;
  enrollment: DeviceEnrollment;
  onClose: () => void;
  onInstallationChange?: (installation: DeviceInstallation) => void;
}) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    await navigator.clipboard.writeText(enrollment.install_command);
    setCopied(true);
  }

  return (
    <section className="enrollment-card" aria-label={`Installation für ${deviceLabel}`}>
      <div className="enrollment-heading">
        <div><h3>{deviceLabel} installieren</h3></div>
        <button type="button" className="close-button" onClick={onClose}>Schließen</button>
      </div>
      <p>Führe diesen Befehl auf dem Raspberry Pi aus. Danach werden nur der CSV-Ordner und der laufende systemd-Dienst abgefragt.</p>
      <textarea readOnly rows={7} value={enrollment.install_command} aria-label="Installationsbefehl" />
      <div className="enrollment-actions">
        <button type="button" className="primary-button" onClick={() => void copy()}>{copied ? "Kopiert" : "Befehl kopieren"}</button>
        <small>Einmalig verwendbar · gültig bis {new Date(enrollment.expires_at).toLocaleTimeString(displayLocale, { hour: "2-digit", minute: "2-digit" })}</small>
      </div>
      <InstallationProgress installationID={enrollment.installation_id} preparedExpiresAt={enrollment.expires_at} onChange={onInstallationChange} />
      <p className="enrollment-warning">Der Befehl enthält eine kurz gültige Geräteaktivierung. Nicht weitergeben oder in Dokumenten speichern.</p>
    </section>
  );
}
